import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HeatwaveDataService } from '../heatwave-data.service';
import { forkJoin } from 'rxjs';
import { UtilsService } from 'src/app/utils/utils.service';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import * as Highcharts from 'highcharts';
import { isNullOrUndefined, log } from 'util';
import { LOCATION_HIE } from '../heatwave-map/heatwave-map-constants';
import { AccuracyPopupDataTableComponent } from 'src/app/main/shared/accuracy-popup-data-table/accuracy-popup-data-table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-heatwave-infobox',
  templateUrl: './heatwave-infobox.component.html',
  styleUrls: ['./heatwave-infobox.component.scss']
})
export class HeatwaveInfoboxComponent implements OnInit {

  @ViewChild("container", { read: ElementRef, static: false }) public container: ElementRef;

  ACTUAL_URL = "heatWatches/getActualHeatWaveCount";
  ACCURACY_URL = "hw/getHWAccuracyData";
  DISTRICT_URL = "heatWatches/getHeatWatchesCount";
  queryParams: any = {};
  selectedSource: any = 'IMD_LONG_RANGE'
  stateData: any;
  selectedState: any;
  selectedDistrict: string = '';
  selectedLocType: any;
  tableDataMandal: any;
  chartData: any;
  formattedChartData: any;
  blocksArray: any;
  count: any;
  highcharts = Highcharts;
  showChart: boolean = true;
  dates: string[] = [];
  tableRows: any[] = [];
  dataCount = {
    severeHeatwave: null,
    heatWave: null,
    normal: null,
    count: null,
    accuracy: null
  }  // chartOptions: Highcharts.Options;
  actualData: any;
  inputForBreadcrumb: any = [];
  categoryList: {};
  filteredData: { normal: any; heat_waves: any; severe_heat_waves: any; };
  showLastLevelTable: boolean = false
  totalCategoryCount: any;
  type: any;
  categoryTypes: any;
  selectedTimeStamp: any;
  hwCountTableData: any;
  hwCatagoryTableData: any;
  selectedComponent: string;

  constructor(private route: ActivatedRoute,
    private dataSrv: HeatwaveDataService,
    private utils: UtilsService,
    private gisMapComp: GisDimsMapComponent,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.selectedComponent = router.url.split('/')[2];
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
      this.selectedLocType = this.queryParams['params']['locType']
      this.getHeirarchyData();
      if (this.queryParams['params'].locType == 'COUNTRY' || this.queryParams['params'].locType == 'STATE') {
        this.getStateData();
        // this.initializeChart();
      } else if (this.queryParams['params'].locType == 'DISTRICT') {

        this.getDistrictData();
        this.setLastLevelTableData()
      }
    })
    this.utils.heatwaveMetaData.subscribe(data => {
  if (data) {
    this.dataCount = data;
  }
});
  }

  getHeirarchyObj() {
    const heirarchyObj = {};
    heirarchyObj['locName'] = this.queryParams['params']['locName'];
    heirarchyObj['locUUID'] = this.queryParams['params']['pUUID'];
    heirarchyObj['locType'] = this.queryParams['params']['locType'];
    heirarchyObj['component'] = 'VL';
    heirarchyObj['view'] = 'ADMIN';
    heirarchyObj['pEUUID'] = 'cc88f822-8474-48d4-8327-4c85444e4a30';

    return heirarchyObj;
  }

  getHeirarchyData() {
    const heirarchyObj = this.getHeirarchyObj();
    let metaInfo: any = localStorage.getItem('metaInfo')
    let metaInfoJSON = JSON.parse(metaInfo)
    let userlocType;
    if(metaInfoJSON && metaInfoJSON.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJSON.userDetailsJson)) {
      userlocType = metaInfoJSON.userDetailsJson.data.locType
    } else {
      userlocType = 'Country'
    }
    userlocType = userlocType.toUpperCase()
    let userLocHie = LOCATION_HIE
    let locTypeIndex = userLocHie.indexOf(userlocType);
    const hie = userLocHie.slice(locTypeIndex, 3);
    this.dataSrv.getHeirarchy(heirarchyObj).subscribe(data => {
      this.inputForBreadcrumb = [];
      if (!isNullOrUndefined(data) && Object.keys(data).length > 0) {
        data.forEach(element => {
          let obj = {
            locType: element['locType'],
            locationID: element['locationID'],
            locationName: element['ln'],
            locationUUID: element['lUUID'],
            clickable: hie.includes(element['locType'])
          }
          this.inputForBreadcrumb.push(obj);
        });
        this.inputForBreadcrumb = this.inputForBreadcrumb.reverse();
      }
    });
  }

  handleEventFromBreadcrumb(data) {
    // console.log("\n data!!!!",data);
    let currentUrlParams = { ...this.queryParams['params'] }
    let locType = data['selectedLocation']['locType']
    let location = currentUrlParams['location']
    let options = this.updateBreadCrumbOptions(locType, location, currentUrlParams)

    this.router.navigate(['/heatwatch/heatwave/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }


  async getStateData() {
    let heatWaveCount: any
    let locTypes: any;
    if (this.queryParams['params'].locType == 'COUNTRY') {
      heatWaveCount = this.getPostDataForStateHeatWaveCount();
      locTypes = 'Country';
    } else if (this.queryParams['params'].locType == 'STATE') {
      heatWaveCount = this.getPostDataForDistrictHeatWaveCount();
      locTypes = 'State';
    }
    let actualData = this.getPostDataForStateAndDistrictActualData();
    let accuracyData = this.getPostDataForAccuracyData();
    let accuracyDataForCountry = this.getPostDataForAccuracyDataForCountry();
    let stateData = new Promise((resolve, reject) => {
      forkJoin(this.dataSrv.getTableDistrictData(heatWaveCount), this.dataSrv.getTableActualData(actualData), this.dataSrv.getTableAccuracyData(accuracyData), this.dataSrv.getTableAccuracyData(accuracyDataForCountry)).subscribe(async (response: any) => {
        // if (response[0] && response[1] && response[2]) {
          if (this.queryParams['params'].locType == 'COUNTRY') {
            // console.log(response[0], response[1], response[2], "response[0], response[1], response[2]")
            this.stateData = this.dataSrv.formatStateData(response[0], response[1], response[2]);
            // console.log(this.stateData, "sssssssssssss")
            this.actualData = response[1]
            let chartWholeData = this.dataSrv.formatChartData(response[0], "Heat Wave Band", response[1]);
            if (chartWholeData) {
              this.chartData = chartWholeData[0]
              this.formattedChartData = chartWholeData[1]
              this.blocksArray = chartWholeData[2]
              this.count = chartWholeData[3]
              this.initializeChart();
              this.prepareTableData(this.chartData);
              this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[3]);
            }
          }
          else if (this.queryParams['params'].locType == 'STATE') {
            this.stateData = this.dataSrv.formatDistrictData(response[0], response[1], response[2]);
            let chartWholeData = this.dataSrv.formatChartData(response[0], "Heat Wave Band", response[1]);
            if (chartWholeData) {
              this.chartData = chartWholeData[0]
              this.formattedChartData = chartWholeData[1]
              this.blocksArray = chartWholeData[2]
              setTimeout(() => {
                this.initializeChart();
              }, 500);
              this.prepareTableData(this.chartData);
              this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[3]);
            }

          }
        // }
        let date = this.dataSrv.getCurrentDateInYYYYMMDDFormat();
        let dates = (this.utils.convertModelDatetoDate(date).toLocaleDateString())
        this.dataCount.severeHeatwave = (this.formattedChartData[0][dates])
        this.dataCount.heatWave = (this.formattedChartData[1][dates])
        this.dataCount.normal = (this.formattedChartData[2][dates])
        this.dataCount.count = this.dataCount.severeHeatwave + this.dataCount.heatWave + this.dataCount.normal
        this.utils.heatwaveMetaData.next(this.dataCount)
      })
    })
    await Promise.all([stateData]).then(async (payloads) => {
      let payloadData: any = await payloads[0];
    });
  }

  async getDistrictData() {
    let districtHeatWaveCount: any
    let blockActualData: any;
    let blockAccuracyData: any;
    let heatWaveCount:any;
    let actualData;
    let accuracyDataForCountry;
    if (this.queryParams['params'].locType == 'DISTRICT') {
      districtHeatWaveCount = this.getPostDataForBlockHeatWaveCount();
      blockActualData = this.getPostDataForBlockActualData();
      blockAccuracyData = this.getPostDataForBlockAccuracyData();
      heatWaveCount = this.getPostDataForDistrictHeatWaveCount();
      actualData = this.getPostDataForStateAndDistrictActualData()
      accuracyDataForCountry = this.getPostDataForAccuracyDataForCountry();
    }
    let stateData = new Promise((resolve, reject) => {
      forkJoin(this.dataSrv.getTableBlockHeatWaveData(districtHeatWaveCount), this.dataSrv.getTableBlockActualData(blockActualData), this.dataSrv.getTableAccuracyData(blockAccuracyData),this.dataSrv.getTableDistrictData(heatWaveCount), this.dataSrv.getTableActualData(actualData),this.dataSrv.getTableAccuracyData(accuracyDataForCountry)).subscribe(async (response: any) => {
        this.tableDataMandal = await this.dataSrv.formatMandalDataForTable(response[0], "hwv", "hwc", response[1], response[2]);
        let chartWholeData = this.dataSrv.formatChartData(response[3], "Heat Wave Band", response[4]);
        if (chartWholeData) {
          this.formattedChartData = chartWholeData[1]
          let allLocations = this.queryParams['params']['location']
          let locationStr = allLocations.split('&')[1]
          let stateUUID = locationStr.split('##')[1]
          this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[5]);
        }
        let date = this.dataSrv.getCurrentDateInYYYYMMDDFormat();
        let dates = (this.utils.convertModelDatetoDate(date).toLocaleDateString())
        this.dataCount.severeHeatwave = (this.formattedChartData[0][dates])
        this.dataCount.heatWave = (this.formattedChartData[1][dates])
        this.dataCount.normal = (this.formattedChartData[2][dates])
        this.dataCount.count = this.dataCount.severeHeatwave + this.dataCount.heatWave + this.dataCount.normal
        console.log("dataCount",this.dataCount);

        this.utils.heatwaveMetaData.next(this.dataCount)
      })
    })
    await Promise.all([stateData]).then(async (payloads) => {
      let payloadData: any = await payloads[0];
    });
  }

  getPostDataForStateHeatWaveCount() {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData: any = {
      component: "HEATWAVE",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "cType": "STATE",
      "countLocationType": "DISTRICT",
      "source": this.queryParams['params']['source'],
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForDistrictHeatWaveCount() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = locationStr.split('&')[1];
    let stateUUID = locationParts.split('##')[1]
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 1] : this.queryParams['params'].locType;
    let firstLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 2] : hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData: any = {
      "pUUID": stateUUID,
      "sUUID": stateUUID,
      "pType": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].locType : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": currentLevel,
      "component": "HEATWAVE",
      "countLocationType": firstLevel,
      "source": this.queryParams['params']['source'],
      "startTs":startTs,
      "endTs":endTs
    }
    return postData;
  }

  getPostDataForBlockHeatWaveCount() {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let locationParts2 = locationStr.split('&')[2];
    let stateUUID = locationParts1.split('##')[1];
    let districtUUID = locationParts2.split('##')[1];
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": this.queryParams['params']['locType'],
      "cType": currentLevel,
      "source": this.queryParams['params']['source'],
      "startTs": startTs,
      "endTs":endTs
    }
    return postData;
  }

  getPostDataForStateAndDistrictActualData() {
    let allLocations = this.queryParams['params']['location']
    let stateUUID;
    if(this.queryParams['params']['locType'] == 'DISTRICT') {
      let locationStr = allLocations.split('&')[1]
      stateUUID = locationStr.split('##')[1]
    }
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 1] : this.queryParams['params'].locType;
    let firstLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 2] : hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].pUUID : stateUUID,
      "pUUID": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].pUUID : stateUUID,
      "pType": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": currentLevel,
      "countLocationType": firstLevel,
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForBlockActualData() {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let locationParts2 = locationStr.split('&')[2];
    let stateUUID = locationParts1.split('##')[1];
    let districtUUID = locationParts2.split('##')[1];
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": this.queryParams['params'].locType,
      "cType": firstLevel,
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForAccuracyData() {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 2];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params']['pUUID'],
      "pUUID": this.queryParams['params']['pUUID'],
      "timePeriod": 'LASTKNOWN',
      "pType": this.queryParams['params']['locType'],
      "cType": currentLevel,
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForAccuracyDataForCountry() {
    let locationStr = this.queryParams['params'].location;
    let stateUUID;
    if(this.queryParams['params']['locType'] == 'DISTRICT') {
      let locationParts = locationStr.split('&')[1];
      stateUUID = locationParts.split('##')[1];
    }
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['pUUID'] : stateUUID,
      "pUUID": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['pUUID'] : stateUUID,
      "timePeriod": 'LASTKNOWN',
      "pType": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForBlockAccuracyData() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = locationStr.split('&')[1];
    let stateUUID = locationParts.split('##')[1];

    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": stateUUID,
      "timePeriod": 'LASTKNOWN',
      "pType": currentLevel,
      "cType": firstLevel,
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getTextColor(bg: string): string {
    const darkColors = ['#B22222'];
    return darkColors.includes(bg) ? 'white' : 'black';
  }

  onStateClick(row: any) {
    let options: any = { ...this.queryParams };
    let allLocations: any = this.queryParams['params']['location'].split('&');
    this.onLocationClick(row, allLocations, options);
  }

  onLocationClick(row: any, allLocations: any, options: any) {
    let mergeOptions = this.updateOptions(row, allLocations, options);
    this.router.navigate(['/heatwatch/heatwave/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });

  }

  updateOptions(row: any, allLocations: any, options: any) {
    const stateKeys = Object.keys(row);
    const stateKey = stateKeys.find(k => k === "State");
    let stateName: any;
    let districtName: any;
    if (this.queryParams['params'].locType == 'COUNTRY') {
      stateName = row['State'].val;
    } else if (this.queryParams['params'].locType == 'STATE') {
      districtName = row['District'].val;
    }
    if (row['uuid'] && this.queryParams['params'].locType == 'COUNTRY') {
      options['locType'] = 'STATE';
      options['pUUID'] = row['uuid'];
      options['locName'] = this.utils.titleCase(stateName);
      options['location'] = allLocations[0] + '&' + this.utils.titleCase(stateName) + '##' + row['uuid'];
    } else if (row['uuid'] && this.queryParams['params'].locType == 'STATE') {
      options['locType'] = 'DISTRICT';
      options['pUUID'] = row['uuid'];
      options['locName'] = this.utils.titleCase(districtName);
      options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + this.utils.titleCase(districtName) + '##' + row['uuid'];
    }
    return options;
  }

  resetBreadcrumb(locType: any) {
    let options: any = { ...this.queryParams };
    let allLocations: any = this.queryParams['params']['location'].split('&');
    this.onLocationBreadCrumbClick(locType, allLocations, options);
  }

  onLocationBreadCrumbClick(locType, allLocations, options) {
    let mergeOptions = this.updateBreadCrumbOptions(locType, allLocations, options);
    this.router.navigate(['/heatwatch/heatwave/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

  updateBreadCrumbOptions(locType, allLocations, options) {
    let location;
    if (locType == 'COUNTRY') {
      location = allLocations.split('&')[0]
      options['locType'] = 'COUNTRY'
      options['locName'] = location.split('##')[0]
      options['location'] = allLocations.split('&')[0]
      options['pUUID'] = location.split('##')[1]
    } else if (locType == 'STATE') {
      location = allLocations.split('&')[1]
      options['locType'] = 'STATE'
      options['locName'] = location.split('##')[0]
      options['location'] = allLocations.split('&')[0] + '&' + allLocations.split('&')[1]
      options['pUUID'] = location.split('##')[1]
    }
    // else {
    //   location = allLocations.split('&')[0] + '&' + allLocations.split('&')[1] + '&' + allLocations.split('&')[2]
    // }
    return options
  }

  initializeChart(): void {
    if (!this.chartData || !this.chartData.Normal || !this.chartData.Heatwave || !this.chartData.SevereHeatwave) {
      // console.warn('Chart data is not properly defined');
      return;
    }
    const categories = Object.keys(this.chartData.Normal || {});
    let chartData = this.dataSrv.getChartData(categories, this.chartData, this.queryParams['params']);
    this.highcharts.chart(this.container.nativeElement, chartData)
  }

  onButtonClick(view: 'chart' | 'table') {
    this.showChart = view === 'chart';
  }

  toggleTableChart() {
    this.showChart = !this.showChart
    if (this.showChart) {
      setTimeout(() => {
        this.initializeChart()
      }, 200)
    }
  }

  prepareTableData(data: any) {
    this.dates = Object.keys(data.SevereHeatwave);
    this.tableRows = Object.keys(data).map((category) => {
      return {
        category: category === 'SevereHeatwave' ? 'Severe Heatwave' : category,
        values: this.dates.map(date => data[category][date] !== undefined ? data[category][date] : 0)
      };
    });
  }

  getOverallAccuracyDataForState(actualData, stateUUID) {
    this.dataCount.accuracy = this.dataSrv.getOverallAccuracyDataForState(actualData, stateUUID);
  }

  setLastLevelTableData() {
    this.utils.getTimeStamp().subscribe(async date => {
      if (date) {
        let blockNumber = this.dataSrv.setBlockNumber()
        if (blockNumber == 3) {
          date = date + 1
        }
        this.selectedTimeStamp = date.toString()
        if (!isNullOrUndefined(this.hwCountTableData) && !isNullOrUndefined(this.hwCatagoryTableData)) {
          this.getHWCountTableData(this.hwCountTableData)
          this.getHWCategoryTableData(this.hwCatagoryTableData)
        }
      }
    })
    this.utils.schoolCheckBoxClicked.subscribe(data => {
      // this.getSchoolAlertCount();
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Schools'
          this.getCategoryCount('SCHOOL');
          this.getHeatWaveCount('SCHOOL');
        }
      } else {
        this.showLastLevelTable = false
      }
    });
    this.utils.CheckBoxAngaClicked.subscribe(data => {
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Anganwadis'
          this.getHeatWaveCount('ANGANWADI');
        } else {
          this.showLastLevelTable = false
        }
      }
    });
    this.utils.CheckBoxHealthCareClicked.subscribe(data => {
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Healthcares'
          this.getCategoryCount('HEALTHCARE');
          this.getHeatWaveCount('HEALTHCARE');
        } else {
          this.showLastLevelTable = false
        }
      }
    });
  }

  getStartEndTS() {
    let timestampObj = {}
    let blockNumber = this.dataSrv.setBlockNumber()
    const now = new Date();
    let startTs;
    let endDate;

    // Start of today (00:00:00)
    if (blockNumber == 2) {
      startTs = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
      endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5);
    } else {
      startTs = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 6);
    }

    // End of 7 days from now (23:59:59)
    endDate.setHours(23, 59, 59, 999);
    let endTs = endDate.getTime();
    timestampObj['startTs'] = startTs
    timestampObj['endTs'] = endTs
    return timestampObj
  }

  getHeatWaveCount(type) {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let stateUUID = locationParts1.split('##')[1];
    let locationParts2 = locationStr.split('&')[2]
    let districtUUID = locationParts2.split('##')[1];
    let timestampObj = this.getStartEndTS()
    this.hwCountTableData = {}
    const postData = {
      "stateUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": "DISTRICT",
      "cType": "BLOCK",
      "locType": type,
      "source": this.queryParams['params']['source'],
      "startTs": timestampObj['startTs'],
      "endTs": timestampObj['endTs'],
      "component": "heatwave"
    }
    this.utils.getSchoolHeatWaveCategoryCount(postData).subscribe(data => {
      this.categoryList = {};
      this.hwCountTableData = data
      this.showLastLevelTable = true
      this.getHWCountTableData(data)
    });
  }

  getHWCountTableData(data) {
    const districtData = data[this.selectedTimeStamp];
    const districtUUID = districtData ? Object.keys(districtData)[0] : null;
    if (districtData[this.queryParams['params']['pUUID']]) {
      this.categoryList = districtData[districtUUID];
      this.totalCategoryCount = 0
      Object.keys(this.categoryList).forEach(key => {
        this.totalCategoryCount += this.categoryList[key]
      })
    } else {
      this.categoryList = {
        normal: '-',
        severe_heat_waves: '-',
        heat_waves: '-'
      };
    }
    // console.log("this.categoryList", this.categoryList);
  }

  getCategoryCount(type) {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let stateUUID = locationParts1.split('##')[1];
    let locationParts2 = locationStr.split('&')[2]
    let districtUUID = locationParts2.split('##')[1];
    const now = new Date();
    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const timestamp = todayMidnight.getTime();
    const timestamps = timestamp;
    const date = new Date(timestamps);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const timestampStr = `${year}${month}${day}`;
    let timestampObj = this.getStartEndTS()
    this.hwCatagoryTableData = {}

    const postData = {
      "stateUUID": stateUUID,
      "pUUID": districtUUID,
      "src": this.queryParams['params']['source'],
      "cType": "BLOCK",
      "startTs": timestampObj['startTs'],
      "endTs": timestampObj['endTs'],
      "locType": type,
      "component": "heatwave"
    }
    this.utils.getSchooleAlertCount(postData).subscribe(data => {
      this.hwCatagoryTableData = data
      this.getHWCategoryTableData(data)
    });
  }

  getHWCategoryTableData(data) {
    const dateLevelData = data[this.selectedTimeStamp];
    if (dateLevelData) {
      const uuid = Object.keys(dateLevelData)[0]; // Get the first UUID key
      const categoryData = dateLevelData[uuid];

      if (categoryData) {
        this.filteredData = {
          normal: categoryData.normal || {},
          heat_waves: categoryData.heat_waves || {},
          severe_heat_waves: categoryData.severe_heat_waves || {}
        };
      } else {
        this.filteredData = {
          normal: {},
          heat_waves: {},
          severe_heat_waves: {}
        };
      }

      this.categoryTypes = Array.from(new Set([
        ...Object.keys(this.filteredData.normal || {}),
        ...Object.keys(this.filteredData.heat_waves || {}),
        ...Object.keys(this.filteredData.severe_heat_waves || {})
      ]));
      // console.log(this.filteredData, "filteredData")
    }
  }

  hasAnyData(category: string): boolean {
    return (
      (this.filteredData.normal && this.filteredData.normal[category] != null) ||
      (this.filteredData.heat_waves && this.filteredData.heat_waves[category] != null) ||
      (this.filteredData.severe_heat_waves && this.filteredData.severe_heat_waves[category] != null)
    );
  }

  openAccuracyPopup() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = this.queryParams['params']['locType'] != 'COUNTRY' ? locationStr.split('&')[1] : locationStr.split('&')[0];
    let stateUUID = locationParts.split('##')[1];
    let locName = this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locName'] : locationParts.split('##')[0]
    const modalRef = this.modalService.open(AccuracyPopupDataTableComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-dark size-large',
      backdrop: 'static'
    });
    // modalRef.componentInstance.title = title;
    modalRef.componentInstance.queryParams = this.queryParams['params']
    modalRef.componentInstance.selectedState = locName
    modalRef.componentInstance.stateUUID = stateUUID
    modalRef.componentInstance.locType = this.queryParams['params']['locType']
  }

  closePanel() {
    if (this.gisMapComp.dataTabToggleVal) {
      this.gisMapComp.dataTabToggle();
    }
  }

  exportexcel() {
    const element = document.getElementById('gis-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    this.selectedSource = this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF'
    let sourceText: any;
    sourceText = ['Source: ' + this.selectedSource];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const newWs: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([sourceText, []]);
    const originalData = XLSX.utils.sheet_to_json(ws, { header: 1 }) as string[][];
    XLSX.utils.sheet_add_aoa(newWs, originalData, { origin: 'A3' });
    XLSX.utils.book_append_sheet(wb, newWs, 'Sheet1');
    let fileName: any;
    fileName = `${this.selectedComponent}_${this.selectedSource}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

}
